import { defineStore } from 'pinia'

import { useAjax } from '@composables/useAjax.js'

// const property = ref(null)
let activeCode = null
let cache = {}
let paths = {}

const CACHE_STORAGE_KEY = 'sorted_properties'

export const useStore = defineStore('properties', {
  state: () => ({
    activeBy: null,
    activeProperty: null, // MAPでポップアップ表示している物件
    properties: null, // 物件一覧（コードとパスのみ）
    cities: null
  }),

  actions: {
    /**
     * アクティブ状態の設定
     */
    async active(code, by) {
      activeCode = code
      if (!cache[code]) {
        await useStore().getProperty(code)
      }

      if (activeCode == code) { // 物件情報を取得している最中にアクティブな物件が変わる可能性がある
        this.activeProperty = cache[code]
        this.activeBy = by
      }
    },

    /**
     * URLが同じで物件情報も同じだったら前回の結果を使用する（ランダム部分を再利用するため）
     */
    cachedStorage(properties) {
      const storage = sessionStorage.getItem(CACHE_STORAGE_KEY)
      if (!storage) {
        return null
      }

      const json = JSON.parse(storage)
      if (json.u !== window.app.common.cacheKey[window.app.page.type] ||
        json.url !== this.urlKey()) {
        return null
      }

      const codes1 = json.properties.map((code) => code).sort()
      const codes2 = properties.map((property) => property.code).sort()

      return codes1.every((val, index) => val === codes2[index]) ? json.properties : null
    },

    /**
     * 物件情報の取得
     */
    async getProperty(code) {
      const { callGet } = useAjax()
      const response = await callGet(paths[code])
      if (response.property) {
        cache[response.property.code] = response.property
      }
      return response
    },

    /**
     * 物件一覧の取得
     */
    async getProperties() {
      const { callGet } = useAjax()
      const url = new URL(location.href)
      url.pathname = `${url.pathname.replace(/\/$/, '')}.json`
      url.searchParams.delete('page')
      url.searchParams.delete('m')
      url.searchParams.append('u', window.app.common.cacheKey[window.app.page.type])
      const response = await callGet(url.toString())

      if (response.properties && response.properties.length > 0) {
        this.properties = this.sortProperties(response.properties)
        this.cities = response.cities
        this.properties.forEach((property) => paths[property.code] = property.path)
      }
      else {
        this.properties = []
      }
    },

    /**
     * アクティブ状態の解除
     */
    resetActive() {
      this.activeProperty = null
    },

    /**
     * 物件一覧のソート
     */
    sortProperties(properties) {
      if (window.app.page.search_key.sort) {
        return properties
      }

      const cached = this.cachedStorage(properties)
      if (cached) {
        const order = new Map(cached.map((v, i) => [v, i]));
        return properties.sort((x, y) => order.get(x.code) - order.get(y.code));
      }

      const result = properties.sort((a, b) => {
        if (a.sort_rank === b.sort_rank) {
          return Math.random() - 0.5
        }
        return a.sort_rank - b.sort_rank
      })

      sessionStorage.setItem(CACHE_STORAGE_KEY, JSON.stringify({
        u: window.app.common.cacheKey[window.app.page.type],
        url: this.urlKey(),
        properties: result.map((property) => property.code)
      }))

      return result
    },

    /**
     * 標準化したURL
     */
    urlKey() {
      const url = new URL(location.href);
      url.searchParams.delete("page");
      url.searchParams.delete("m");
      return url.toString()
    },
  },
})
